module.exports = __webpack_public_path__ + "MamaQueenGeek.webp?7d63c24628bf082e66cd99557ee0aa08";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MamaQueenGeek.webp
// module id = 135
// module chunks = 0